import React from "react";
import { connect } from "react-redux";
import { formatNumber, formatNumberForceSigned } from "../../../lib/commonFunctions";
import { boostHappiness } from "../../../store/actions";

const HappinessBalance = ({
  gold,
  happinessBalance,
  boostHappinessDispatch
}) => (
  <>
    <h3 className="title">Happiness balance</h3>

    <strong>Population happiness:</strong><br/>
    New turn: <span className="positive">+1</span><br/>
    Buildings: <span className={`${happinessBalance.buildings ? "positive" : ""}`}>{formatNumberForceSigned(happinessBalance.buildings)}</span><br/>
    Magic: <span className={happinessBalance.magic < 0 ? "negative" : "positive"}>
      {formatNumberForceSigned(happinessBalance.magic)}
    </span>
    {happinessBalance.defence
      ? <><br />Passed siege: <span className="negative">{formatNumber(happinessBalance.defence)}</span></> : ""}
    {happinessBalance.afterWarBoost
      ? <><br/>Post-war boost: <span className="positive">{formatNumberForceSigned(happinessBalance.afterWarBoost)}</span></> : ""}
    {happinessBalance.boost
      ? <><br/>Happiness boost: <span className="positive">{formatNumberForceSigned(happinessBalance.boost)}</span></> : ""}
    {happinessBalance.famine
      ? <><br/>Food shortage: <span className="negative">{formatNumber(happinessBalance.famine)}</span></> : ""}
    {happinessBalance.bankruptcy
      ? <><br/>Bankruptcy: <span className="negative">{formatNumber(happinessBalance.bankruptcy)}</span></> : ""}
    <br />
    <br />
    <strong>Happiness boost:</strong><br />
    <small>Used this count {happinessBalance.boost > 0 ? "1" : "0"}/1</small>
    {!happinessBalance.boost && <><br />
        +1 <i className="icon icon-xs icon-popularita align-sub"/>
        <a
          className={`btn btn-blank btn-sm ${gold < 200 ? "disabled" : ""}`}
          onClick={() => gold < 200 || boostHappinessDispatch(200)}
        >
          200 <i className="icon icon-xs icon-zlato gold"/>
        </a><br />
        +2 <i className="icon icon-xs icon-popularita align-sub"/>
        <a
          className={`btn btn-blank btn-sm ${gold < 500 ? "disabled" : ""}`}
          onClick={() => gold < 500 || boostHappinessDispatch(500)}
        >
          500 <i className="icon icon-xs icon-zlato gold"/>
        </a>
    </>}
  </>
);

const mapStateToProps = state => ({
  gold: state.governorate.resources.gold,
  happinessBalance: state.governorate.resourceBalances.happiness
});

const mapDispatchToProps = dispatch => ({
  boostHappinessDispatch: gold => dispatch(boostHappiness(gold))
});

export default connect(mapStateToProps, mapDispatchToProps)(HappinessBalance);
